import type { Infer } from 'superstruct';
import {
	boolean,
	nullable,
	number,
	object,
	optional,
	string,
} from 'superstruct';

import { stringDate } from '@adflow/shared/util-superstruct';

export const ViewFacebookMetaManagerDto = object({
	id: number(),
	name: string(),
	businessId: string(),
	isActive: boolean(),

	syncedAt: nullable(stringDate()),
	createdAt: stringDate(),
	updatedAt: stringDate(),
});

export type ViewFacebookMetaManagerDto = Infer<
	typeof ViewFacebookMetaManagerDto
>;

export const AddFacebookMetaManagerDto = object({
	name: string(),
	businessId: string(),
	isActive: optional(boolean()),
});

export type AddFacebookMetaManagerDto = Infer<typeof AddFacebookMetaManagerDto>;

export const EditFacebookMetaManagerDto = object({
	name: optional(string()),
	businessId: optional(string()),
	isActive: optional(boolean()),
});

export type EditFacebookMetaManagerDto = Infer<
	typeof EditFacebookMetaManagerDto
>;
